import React from 'react'
import Back from '../../units/Back/Back'
import { useNavigate } from 'react-router-dom'

const Contacts = () => {
  const navigate = useNavigate()

  return (
    <div>
      <Back
        goBack={() => {
          navigate('/')
        }}
      />
      <h1 style={{ marginTop: 16 }}>Контакты</h1>
      <p>
        Компания: Алкомиг 77
        <br />
        Гео: Москва
        <br />
        Телефон: <a href="tel:+79256562024">+7 (925) 656-20-24</a>
        <br />
        Сайт:{' '}
        <a href="https://77bot.ru" target="_blank" rel="noopener noreferrer">
          77bot.ru
        </a>
      </p>
    </div>
  )
}

export default Contacts
